<template>
  <div class="header">
    <a class="mr-auto" href="/">
      <img
        :src="require('images/logo.png')"
        alt="Reeracoen Freelance Recruiting Business"
      />
    </a>
  </div>
</template>

<script>
import Vue from 'vue'

import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
Vue.use(VueToast)

import { isEmpty } from 'lodash'

const ViewProps = window._application.props

export default {
  data() {
    return {
      flash: ViewProps.flash,
    }
  },

  mounted: function () {
    if (!isEmpty(this.flash)) {
      this.$toast.open({
        message: this.flash[0].message,
        type: this.flash[0].key,
        duration: 5000,
        dismissible: true,
        position: 'top-right',
      })
    }
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';

.header {
  padding: 1.5rem 2rem;

  img {
    width: 200px;
  }
}
</style>
